import { render, staticRenderFns } from "./AsHeadline.vue?vue&type=template&id=428f572a&scoped=true"
var script = {}
import style0 from "./AsHeadline.vue?vue&type=style&index=0&id=428f572a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "428f572a",
  null
  
)

export default component.exports